import policy from "./canonicalPolicy.json";

const safeQueryValue = new RegExp(`^${policy.queryValuePattern}$`);

export const getRouteSEO = (pathname, search = "") => {
  let route = pathname.replace(/\/+$/, "") || "/";
  const detailPrefix = policy.detailPrefixes.find((prefix) => (
    route.startsWith(`${prefix}/`) && !route.slice(prefix.length + 1).includes("/")
  ));
  if (detailPrefix) {
    try {
      let slug = decodeURIComponent(route.slice(detailPrefix.length + 1));
      if (detailPrefix === "/articles") slug = slug.toLowerCase().replace(/\s+/g, "-");
      route = `${detailPrefix}/${encodeURIComponent(slug)}`;
    } catch {
      return { canonical: null, robots: "noindex, follow" };
    }
  }

  if (!detailPrefix && !policy.publicPaths.includes(route)) {
    return { canonical: null, robots: "noindex, follow" };
  }

  const allowedParameters = policy.filterGroups.find((group) => group.paths.includes(route))?.parameters || [];
  const rawParameters = new Map();
  search.replace(/^\?/, "").split("&").forEach((entry) => {
    const separator = entry.indexOf("=");
    if (separator > 0 && !rawParameters.has(entry.slice(0, separator))) {
      rawParameters.set(entry.slice(0, separator), entry.slice(separator + 1));
    }
  });
  const query = [...allowedParameters].sort().flatMap((key) => {
    const value = rawParameters.get(key);
    return value && safeQueryValue.test(value) ? [`${key}=${value}`] : [];
  }).join("&");

  return {
    canonical: `${policy.origin}${route}${query ? `?${query}` : ""}`,
    robots: "index, follow",
  };
};
